// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"177":"home","193":"software","443":"about"}[chunkId] + "-legacy." + {"177":"f4e1574d","193":"5eaaeedc","443":"28c84c91"}[chunkId] + ".js";
};